import { Box, FormControlLabel, FormGroup, Switch, Tooltip, Typography } from '@mui/material';

export function HatDbDomainFilterToggle(props: {
    enabled: boolean;
    onChange: (enabled: boolean) => void;
    advertiserDomain: string | null;
}) {
    const { enabled, onChange, advertiserDomain } = props;

    return (
        <FormGroup>
            <FormControlLabel
                sx={{
                    marginLeft: 0,
                    marginRight: 0,
                    // overflow: 'hidden',
                    // '& > .MuiTypography-root': {
                    //     width: 'calc(100% - 60px)'
                    // }
                }}
                label={
                    <Box sx={{ overflow: 'hidden' }}>
                        <Typography variant="body1" noWrap>
                            Filter to advertiser domain:
                        </Typography>
                        {advertiserDomain && (
                            <Typography variant="body2" noWrap>
                                {advertiserDomain}
                            </Typography>
                        )}
                    </Box>
                }
                control={
                    <Tooltip title="Only show the traffic to the domain on the Advertisers profile.">
                        <Switch
                            checked={enabled}
                            onChange={(event) => {
                                onChange(event.target.checked);
                            }}
                        />
                    </Tooltip>
                }
            />
        </FormGroup>
    );
}
